import { SpecChange, ValidationResult } from './types';

/** snake_case rule names → readable titles ("voltage_mismatch" → "Voltage Mismatch"). */
export const formatRuleName = (name: string) =>
  name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

/** camelCase context fields → readable words ("dutyCycle" → "duty cycle"). */
export const formatFieldName = (field: string) =>
  field
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .toLowerCase();

/** Severity wording follows the engine's rule types, nothing invented. */
export const severityLabel = (r: ValidationResult): string => {
  if (r.ruleType === 'hard' || r.status === 'fail') return 'critical';
  if (r.ruleType === 'info' || r.status === 'info') return 'info';
  return 'warning';
};

/** "Discharge rate 30C → 40C"; a spec the line never stated reads "Current not stated → 60A". */
export const describeSpecChange = (c: SpecChange): string =>
  `${c.label} ${c.from ?? 'not stated'} \u2192 ${c.to}`;

const comparableName = (name: string) => name.toLowerCase().replace(/[^a-z0-9]+/g, '');

/** A swap that keeps the line's name changes only its spec — say so rather than "Swap to <same name>". */
export const swapActionLabel = (originalName: string, targetName: string, changes: SpecChange[]): string =>
  changes.length > 0 && comparableName(originalName) === comparableName(targetName)
    ? `Change to ${changes.map((c) => c.to).join(', ')}`
    : `Swap to ${targetName}`;
